module.exports = __webpack_public_path__ + "static/media/royal-suite-img3.06665b01.jpg";